import { AxiosResponse } from 'axios';
import api from './';
import {
  ReferralAttributionResponse,
  ReferralCodeRequestResponse,
  ReferralDashboard
} from './types/referral';

const fetchReferralDashboard = async () => {
  return await api.get<null, AxiosResponse<ReferralDashboard>>('/users/referral');
};

const attributeReferralCode = async (referralCode: string) => {
  return await api.post<{ referralCode: string }, AxiosResponse<ReferralAttributionResponse>>(
    '/users/referral/attribution',
    {
      referralCode
    }
  );
};

const requestCustomReferralCode = async (requestedCode: string) => {
  return await api.post<{ requestedCode: string }, AxiosResponse<ReferralCodeRequestResponse>>(
    '/users/referral/code-request',
    {
      requestedCode
    }
  );
};

const ReferralsApi = {
  fetchReferralDashboard,
  attributeReferralCode,
  requestCustomReferralCode
};

export default ReferralsApi;
